import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class Navegacion extends Component {
  render() {
    return (
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img className="float-left"
              width="250"
              alt="Logo"
              src={'./../Isologo Blanco.png'}>
            </img>
          </Link>
          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/">Inicio</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/Registro">Registrarse</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/Usuario">Clientes</Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    )
  }
}
